var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",class:_vm.classContents},[_c('v-card',{class:_vm.classContents,attrs:{"flat":""}},[_c('v-card-text',[_c('h3',[_vm._v(_vm._s(_vm.$t('common.under.construction')))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }